import React from 'react'
import { UsageTrend } from '@/types/dashboard'
import { estimateCost, formatNumber } from '@/utils/dashboard-dates-util'
import { cn } from '@/lib/utils'

interface UsageTableProps {
  data: UsageTrend[]
}

const UsageTable: React.FC<UsageTableProps> = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <div className="h-[600px] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-400/90 sticky top-0">
              <tr>
                <th scope="col" className="px-6 py-2 text-left text-sm font-bold text-gray-50 uppercase tracking-wider">
                  Data
                </th>
                <th scope="col" className="px-6 py-2 text-left text-sm font-medium text-gray-50 uppercase tracking-wider">
                  API Requests
                </th>
                <th scope="col" className="px-6 py-2 text-left text-sm font-medium text-gray-50 uppercase tracking-wider">
                  Custo Estimado
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-white">
              {data.map((item, index) => (
                <tr key={index} className={cn('hover:bg-gray-50 transition-colors', index % 2 === 0 ? 'bg-gray-200/70' : 'bg-white')}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.date}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatNumber(item.requests)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">R$ {estimateCost(item.inputTokens || 0, item.outputTokens || 0).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default UsageTable
